import LoadingRippleButton from "./LoadingRippleButton";

interface FilterButtonProps {
  onClick?: () => void;
  label: string;
  disabled?: boolean;
  loading: boolean;
  selected: boolean;
}

const FilterButton: React.FC<FilterButtonProps> = ({
  onClick,
  label,
  selected,
  loading,
  disabled = false,
}) => {
  return (
    <LoadingRippleButton
      onClick={onClick}
      disabled={disabled || loading}
      loading={loading}
      type="submit"
      isActive={selected}
      className="filter-button"
      config={{
        bgColor: "var(--filter-button-bg-color)",
        textColor: "var(--filter-button-text-color)",
        borderColor: "var(--filter-button-border-color)",
        hoverBgColor: "var(--filter-button-hover-bg-color)",
        hoverTextColor: "var(--filter-button-hover-text-color)",
        hoverBorderColor: "var(--filter-button-hover-border-color)",
        activeBgColor: "var(--filter-button-active-bg-color)",
        activeTextColor: "var(--filter-button-active-text-color)",
        activeBorderColor: "var(--filter-button-active-border-color)",
      }}
    >
      {label}
    </LoadingRippleButton>
  );
};

export default FilterButton;
